<template>

    <b-modal id="updateAddress" ref="updateAddressModal" hide-footer @show="getCurrentData">
        <h1 class="text-center mb-50">Deine Daten ändern</h1>
        <div class="mandatory-note text-center">
            <p>* Pflichtfelder bitte ausfüllen</p>
        </div>
        <form>

            <div class="form-row">
                <div class="col-12">
                    <h5>Deine Daten</h5>
                </div>
                <div class="form-group floating-label col-12">
                    <span v-if="valid('firstname')" class='invalid-feedback'>Bitte Vornamen eingeben!</span>
                    <input v-validate="'required'"
                           type="text"
                           name="firstname"
                           class="form-control"
                           placeholder='Vorname'
                           v-model.trim="firstname"/>
                    <label>Vorname *</label>
                </div>
                <div class="form-group floating-label col-12">
                    <span v-if="valid('lastname')" class='invalid-feedback'>Bitte Nachnamen eingeben!</span>
                    <input v-validate="'required'"
                           type="text"
                           name="lastname"
                           class="form-control"
                           placeholder='Nachname'
                           v-model.trim="lastname"/>
                    <label>Nachname *</label>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group floating-label col-8">
                    <div v-if="valid('street')" class="invalid-feedback">Bitte Straße eingeben!</div>
                    <input v-validate="'required'" type="text" name="street" class="form-control"
                           placeholder="Straße" v-model="street">
                    <label>Straße *</label>
                </div>
                <div class="form-group floating-label col-4">
                    <div v-if="valid('housenumber')" class="invalid-feedback">Bitte Hausnummer eingeben!</div>
                    <input v-validate="'required'" type="text" name="housenumber" class="form-control"
                           placeholder="Hausnummer" v-model="housenumber">
                    <label>Hausnummer *</label>
                </div>
            </div>

            <div class="form-row">
                <div class="form-group floating-label col-4">
                    <div v-if="valid('postcode')" class="invalid-feedback">Bitte PLZ eingeben!</div>
                    <input v-validate="'required|numeric'" type="text" name="postcode" class="form-control"
                           placeholder="PLZ" v-model="postcode">
                    <label>PLZ *</label>
                </div>
                <div class="form-group floating-label col-8">
                    <div v-if="valid('city')" class="invalid-feedback">Bitte Ort eingeben!</div>
                    <input v-validate="'required'" type="text" name="city" class="form-control"
                           placeholder="Ort" v-model="city">
                    <label>Ort *</label>
                </div>
            </div>
            <div class="form-row mt-30">
                <div class="form-group col-12">
                    <div v-if="errors.has('country')" class="invalid-feedback">Bitte Land auswählen!</div>
                    <b-form-select v-validate="'required'" name="country" v-model="country">
                        <option :value="null">Land *</option>
                        <option :value="'DE'">Deutschland</option>
                        <option :value="'LU'">Luxemburg</option>
                    </b-form-select>
                </div>
            </div>
            <div class="col-12 mt-60">
                <h5>Dein McDonald's Lieblingsrestaurant</h5>
            </div>
            <div class="form-row">
                <profileChangeFavouriteRestaurantComponent @favoriteRestaurantID="setFavRestaurant"
                                                           ref="typeAheadComponent"/>
            </div>
        </form>

        <footer class="modal-footer yes-no">
            <button type="button" class="btn btn-link" @click="hideModal">Abbrechen</button>
            <button type="button"
                    class="btn btn-primary"
                    :disabled="!completed"
                    @click="updateAddress">Änderungen speichern
            </button>
        </footer>

    </b-modal>
</template>
<script>
    import profileChangeFavouriteRestaurantComponent from './profile-change-favourite-restaurant.vue';
    import {apiChangeAddress} from '../utils/api';

    export default {
        name: 'profileChangeAddressComponent',
        components: {
            profileChangeFavouriteRestaurantComponent
        },
        data() {
            return {
                profileChangeAddressResponse: {},
                country: null,
                firstname: '',
                lastname: '',
                street: '',
                postcode: '',
                housenumber: '',
                city: '',
                favoriteRestaurant: ''
            };
        },
        computed: {
            completed() {
                return Object.keys(this.fields).every(key => this.fields[key].valid)
            }
        },
        methods: {
            updateAddress(e) {
                e.preventDefault();

                let addressProperties = {
                    'street': this.street,
                    'housenumber': this.housenumber,
                    'postcode': this.postcode,
                    'city': this.city,
                    'country': this.country
                };

                //this.$emit(refresh)

                this.$emit('refreshFavRest');

                this.$store.commit('updateProfileChangeAddress', addressProperties);
                this.$store.commit('updateProfileChangeFavoriteRestaurant', this.favoriteRestaurant);

                apiChangeAddress({
                    'email': this.$store.state.profileData.parentEmail,
                    'oldPasswordhash': this.$store.state.user.password,
                    "firstname": this.firstname,
                    "lastname": this.lastname,
                    'address': addressProperties,
                    'favoriteRestaurant': this.favoriteRestaurant
                })
                    .then(response => {

                        // JSON responses are automatically parsed.
                        this.profileChangeAddressResponse = response.data;
                        let code = response.data.code;

                        if (code === 1)
                            this.toast('Passwort unbekannt');
                        else if (code === 2)
                            this.toast('E-Mail-Adresse unbekannt');
                        else if (code === 3)
                            this.toast('Adressdaten des Elternteils nicht in Ordnung');
                        else if (code === 99)
                            this.toast('Pflichtfeld nicht ausgefüllt');
                        else if (code === 105)
                            this.toast('Restaurant unbekannt');

                    })
                    .catch(e => {
                        this.$store.commit('error', e);
                    });

                this.$nextTick(() => {
                    // Wrapped in $nextTick to ensure DOM is rendered before closing
                    this.hideModal();
                });
            },
            toast(text) {
                this.$toasted.error(text, {
                    duration: 3000,
                    position: 'bottom-right'
                });
            },
            setFavRestaurant(val) {
                this.favoriteRestaurant = val;
            },
            hideModal() {
                this.$refs.updateAddressModal.hide();
            },
            valid(name) {
                return this.fields[name] && this.fields[name].touched && !this.fields[name].valid
            },
            getCurrentData() {
                this.country = this.$store.state.profileData.address.country;
                this.street = this.$store.state.profileData.address.street;
                this.firstname = this.$store.state.profileData.firstname;
                this.lastname = this.$store.state.profileData.lastname;
                this.postcode = this.$store.state.profileData.address.postcode;
                this.housenumber = this.$store.state.profileData.address.housenumber;
                this.city = this.$store.state.profileData.address.city;

                this.favoriteRestaurant = this.$store.state.profileData.favoriteRestaurant;
                this.$refs.typeAheadComponent.setInitialRestaurant(this.favoriteRestaurant);
            }
        }
    };
</script>
